import React from "react";
import AppsLanding from "./components/AppsLanding";

const Apps: React.FC = () => {
  return <div className="bg-white"><AppsLanding contactHref="/#contact" /></div>;
};

export default Apps;
